export const GET_OBJECT_SELECTED = 'GET_OBJECT_SELECTED';
export const UPDATE_OBJECT_SELECTED = 'UPDATE_OBJECT_SELECTED';
export const APP_LOADED = 'APP_LOADED';
